package one.healthium.uscreen.ui.layout

import androidx.compose.runtime.compositionLocalOf
import androidx.compose.ui.unit.dp

/**
 * Provides the current CTA bar height so content can add bottom padding
 * to avoid being overlapped by the floating CTA button.
 */
val LocalCtaHeight = compositionLocalOf { 0.dp }

/**
 * Provides the current progress bar height so content can add top padding
 * to avoid being overlapped by the floating progress bar.
 */
val LocalProgressBarHeight = compositionLocalOf { 0.dp }
